// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1joVw","search":"Settings_search__12cyB","filter":"Settings_filter__2QH2E"};